import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Proof } from '@feature/proof';
import { generateProofApi, generateProofOptions } from '@feature/proof/proofGenerator';
import { Id } from '@feature/utils';

const citationProofApi = generateProofApi('/proof-file/citation');
const { getProofsOptions, createOrUpdateProofOptions, deleteProofOptions } = generateProofOptions(
  'citation',
  citationProofApi,
);

export function getCitationProofsOptions(citationId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsOptions(citationId);
}

export function useUploadOrUpdateCitationProof(citationId: Id) {
  const queryClient = useQueryClient();
  return useMutation(createOrUpdateProofOptions(citationId, queryClient));
}

export function useDeleteCitationProof(citationId: Id) {
  const queryClient = useQueryClient();
  return useMutation(deleteProofOptions(citationId, queryClient));
}
